import { render } from "./PlantillaFactura.vue?vue&type=template&id=6b394d93&scoped=true"
import script from "./PlantillaFactura.vue?vue&type=script&lang=js"
export * from "./PlantillaFactura.vue?vue&type=script&lang=js"

import "./PlantillaFactura.vue?vue&type=style&index=0&id=6b394d93&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b394d93"]])

export default __exports__